/**
 * Assegnatario predefinito delle Task commerciali (segnalazione 6bcec0bd).
 * Impostazione di organizzazione `settings.activity_default_assignee`:
 * - vuota / null  -> comportamento storico (nel drawer del Lead: il proprietario del Lead)
 * - 'creator'     -> chi crea la task
 * - uuid utente   -> sempre quella persona
 */
export const ACTIVITY_ASSIGNEE_CREATOR = 'creator';

/**
 * Assegnatario proposto. `null` = nessuna proposta: il drawer e il salvataggio ricadono
 * gia' sull'utente corrente (useDrawerForm / useActivitySave).
 */
export function resolveDefaultActivityAssignee(
  setting: string | null | undefined,
  storicoDefault: string | null
): string | null {
  const value = (setting || '').trim();
  if (!value) return storicoDefault;
  if (value === ACTIVITY_ASSIGNEE_CREATOR) return null;
  return value;
}

/** Composer inline: storicamente assegna a chi scrive; solo un utente fisso lo cambia. */
export function resolveComposerAssignee(setting: string | null | undefined, currentUserId: string | null): string | null {
  return resolveDefaultActivityAssignee(setting, currentUserId) || currentUserId;
}
